export const DEFAULT_PAGE_SIZE = 25;
export const TASKS_PAGE_SIZE = 10;
export const EMPLOYEES_PAGE_SIZE = 25;

export const ORDERS_PAGE_SIZE = 25;
export const INTERNAL_ORDER_MANAGEMENT_PAGE_SIZE = 30;
export const HARDWARE_QUOTES_PAGE_SIZE = 25;

export const STOREFRONT_PAGE_SIZE = 9;
export const CATALOG_PRODUCTS_PAGE_SIZE = 30;

export const WAUTOPILOT_MS_TENANTS_PAGE_SIZE = 5;
// Since there is no pagination for the MS Tenants list during checkout,
// we use a value significantly higher than expected to avoid omitting any items
export const WAUTOPILOT_CHECKOUT_MS_TENANTS_PAGE_SIZE = 100;
